import { fetchAPI } from '../helpers';
import AppContext from '../AppContext';

class NotificationService {
    // Notifications
    static newNotification = (groupId, title, content, color, attachments) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token: token,
            url: `${config.IdentityService}${platformId}/notification`,
            method: 'PUT',
            body: {
                groupId,
                title,
                content,
                color,
                attachments
            }
        });
    };

    static getNotification = notificationId => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token: token,
            url: `${config.IdentityService}${platformId}/notification/${notificationId}`,
            method: 'GET',
            body: undefined
        });
    };

    static updateTitleAndContent = (notificationId, title, content, color, attachments) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token: token,
            url: `${config.IdentityService}${platformId}/notification/${notificationId}`,
            method: 'PUT',
            body: {
                title,
                content,
                color,
                attachments
            }
        });
    };

    static deleteNotification = notificationId => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token: token,
            url: `${config.IdentityService}${platformId}/notification/${notificationId}`,
            method: 'DELETE',
            body: {}
        });
    };

    static sendNotification = notificationId => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token: token,
            url: `${config.IdentityService}${platformId}/notification/${notificationId}/send`,
            method: 'PUT',
            body: {}
        });
    };

    static listOwnNotifications = lastKey => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token: token,
            url: `${config.IdentityService}${platformId}/notifications`,
            method: 'PUT',
            body: {
                lastKey
            }
        });
    };

    // Messages
    static listMessages = (cacheTTL = 30000) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI(
            {
                token: token,
                url: `${config.IdentityService}${platformId}/messages`,
                method: 'GET',
                body: undefined
            },
            undefined,
            { active: true, ttl: cacheTTL }
        );
    };

    static getNewMessageCount = (cacheTTL = 30000) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI(
            {
                token: token,
                url: `${config.IdentityService}${platformId}/messages?count=true`,
                method: 'GET',
                body: undefined
            },
            undefined,
            { active: true, ttl: cacheTTL }
        );
    };

    static getMessage = messageId => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI(
            {
                token: token,
                url: `${config.IdentityService}${platformId}/message/${messageId}`,
                method: 'GET',
                body: undefined
            },
            undefined,
            { active: true, ttl: 30000 }
        );
    };

    static checkMessage = messageId => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token: token,
            url: `${config.IdentityService}${platformId}/message/${messageId}`,
            method: 'PUT',
            body: {}
        });
    };

    static deleteMessage = messageId => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token: token,
            url: `${config.IdentityService}${platformId}/message/${messageId}`,
            method: 'DELETE',
            body: {}
        });
    };
}

export default NotificationService;
